const actions = {
  SET_STATE: "displayProfile/SET_STATE",
  LIST: "displayProfile/LIST",
  CREATE: "displayProfile/CREATE",
  DETAIL: "displayProfile/DETAIL",
  UPDATE: "displayProfile/UPDATE",
  DELETE: "displayProfile/DELETE",
};

export default actions;
